export default function FloatingContactButton() {
  return null;
}
